import { ca } from '@cian/analytics';

export const trackConfirmClick = (isAutoprolong: boolean, label: string) => {
  const action = isAutoprolong ? 'try_to_buy_prolong' : 'try_to_buy';

  ca('eventSite', {
    name: 'oldevent',
    category: 'LK_Packages',
    action,
    label,
  });
};

export const trackCancelClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PersonalOffers',
    action: 'Click',
    label: `CancelOffer/${label}`,
  });
};
